module.exports = __webpack_public_path__ + "img/huagong.3e2e94c1.png";